import { create } from "zustand";

export type ProfileEditTab =
  | "header"
  | "about"
  | "education"
  | "certificates"
  | "subjects"
  | "languages"
  | "settings";

interface ProfileEditDialogState {
  isOpen: boolean;
  activeTab: ProfileEditTab;
  open: (tab?: ProfileEditTab) => void;
  close: () => void;
  setTab: (tab: ProfileEditTab) => void;
}

export const useProfileEditDialogStore = create<ProfileEditDialogState>((set) => ({
  isOpen: false,
  activeTab: "header",
  open: (tab?: ProfileEditTab) => set({ isOpen: true, activeTab: tab ?? "header" }),
  close: () => set({ isOpen: false }),
  setTab: (tab: ProfileEditTab) => set({ activeTab: tab }),
}));


